import { Badge } from "@mantine/core";

import { global_settings } from "@/config";

const BetaBadge = () => {
  if (!global_settings.enableBetaUIElements) return null;

  return (
    <Badge bg="#67cbe2" c="#222" p="md" py={12} fz="xs">
      Beta tester
    </Badge>
  );
};

export default BetaBadge;
